module.exports = __webpack_public_path__ + "img/austria-male.1942a9f5.png";